import { generateTheme } from '@cld/theme-helper';
import light from '@cld/themes';

//light theme
const buttonOverride = {
  primary: {
    background: {
      color: 'palette.primary',
    },
  },
  secondary: {
    background: {
      color: 'palette.brand.accentCoral',
    },
    typography: {
      type: 'contrastInvert',
    },
  },
};
const lightThemeOverride = {
  palette: {
    primary: 'palette.brand.cloudinaryBlue',
  },
  components: {
    button: {
      pill: buttonOverride,
    },
  },
};
export const theme = {
  ...generateTheme(light, lightThemeOverride),
};
